<!--
 * @Descripttion: 工作台-工作台
 * @version: 
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-12-03 16:09:23
 * @LastEditors: zhangfan
 * @LastEditTime: 2024-12-09 15:58:47
-->
<template>
  <!-- 工作台 -->
  <div id="workbench">
    <div class="container">
      <div v-if="!bannerHide" class="banner">
        <!-- <img src="../../../assets/images/workbench_banner.png" alt="" /> -->
        <img v-if="bannerImg" :src="bannerImg" alt="" />
        <div class="close" @click="bannerHide = true"></div>
      </div>
      <div class="my-projetc">
        <MyProject v-if="hasWorkbenchAccess" />
        <a-empty v-else description="暂无权限" class="no-auth" :image="require('@/assets/images/empty-data.png')" />
      </div>
    </div>
  </div>
</template>
<script>
import MyProject from './MyProject/index.vue'
import { getBannerData } from '@/api/workbench'
import { hasPermission } from '@/utils/auth'
export default {
  components: {
    MyProject,
  },
  data() {
    return {
      bannerHide: false,
      bannerImg:''
    }
  },
  computed: {
    hasWorkbenchAccess() {
      return hasPermission('web_workbench') || hasPermission('web_my_template') || hasPermission('web_recycle_bin')
    }
  },
  mounted() {
    this.getBannerData()
  },
  methods: {
    async getBannerData() {
      const payload = {
        bannerCount: 1,
        templateCount: 8
      }
      const res = await getBannerData(payload)
      this.bannerImg = res.data.bannerData[0].coverImage
    },
  }
}
</script>
<style scoped lang="less">
#workbench {
  width: 100%;
  height: 100%;
  background-color: #17171a;
  .container {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 6px 0px 0px 0px;
    flex-direction: column;
    .my-projetc {
      flex: 1;
      overflow: hidden;
      .no-auth {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .banner {
    position: relative;
    width: 100%;
    height: 190px;
    margin-bottom: 20px;
    img {
      width: 100%;
      height: 100%;
      vertical-align: middle;
      -webkit-user-drag: none;
      user-select: none;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 36px;
      height: 36px;
      background-color: #fff;
      border-radius: 16px;
      transform: translate(50%, -50%);
      cursor: pointer;
      opacity: 0;
    }
  }
}
</style>
